(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["conlemany-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('conlemany-delivery')) {
    customElements.define('conlemany-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.deliveryController) return;
        const select = this.querySelector('[data-delivery-select]');
        if (!select) return;
        this.deliveryController = new AbortController();
        try {
          const saved = JSON.parse(sessionStorage.getItem('conlemany-delivery-country'));
          if (saved && saved.market === this.dataset.marketCountry && Array.from(select.options).some(option => option.value === saved.country)) select.value = saved.country;
        } catch {}
        const update = () => {
          const selected = select.selectedOptions[0];
          if (!selected) return;
          const country = selected.value;
          const domestic = this.dataset.domestic.split(',').includes(country);
          const europe = this.dataset.europe.split(',').includes(country);
          const international = this.dataset.international.split(',').includes(country);
          const amount = domestic ? '€4.80' : europe ? '€12.00' : international ? '€20.00' : null;
          this.querySelector('[data-delivery-country]').textContent = selected.textContent;
          this.querySelector('[data-delivery-rate]').textContent = amount ? this.dataset.from.replace('__amount__', amount) : this.dataset.calculated;
          this.querySelector('[data-delivery-benefit]').textContent = domestic || europe ? this.dataset.free : this.dataset.weight;
          this.querySelector('[data-delivery-uk]').hidden = country !== 'GB';
          this.querySelector('[data-delivery-threshold]').hidden = !(domestic || europe);
        };
        select.addEventListener('change', () => {
          update();
          try {
            sessionStorage.setItem('conlemany-delivery-country', JSON.stringify({country: select.value, market: this.dataset.marketCountry}));
          } catch {}
        }, {signal: this.deliveryController.signal});
        update();
      }
      disconnectedCallback() {
        this.deliveryController?.abort();
        this.deliveryController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["conlemany-subscription-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('conlemany-subscription-preview')) {
    customElements.define('conlemany-subscription-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.previewController) return;
        this.previewController = new AbortController();
        this.previewSection = this.closest('.shopify-section');
        this.previewTargets = [];
        this.previewNotices = [];
        this.previewActive = false;
        const { signal } = this.previewController;
        const subscribe = this.querySelector('input[value="subscribe"]');
        subscribe.disabled = false;
        this.addEventListener('change', () => this.updatePreview(), { signal });
        this.previewSection?.addEventListener('submit', event => {
          const formComponent = event.target.closest('product-form-component');
          if (this.previewActive && formComponent?.dataset.productId === this.dataset.productId) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.previewSection?.addEventListener('variant:update', event => {
          if (event.detail?.data?.productId && String(event.detail.data.productId) !== this.dataset.productId) return;
          const variantId = event.detail?.resource?.id;
          if (variantId) this.updateVariantPrices(variantId);
          this.querySelector('input[value="once"]').checked = true;
          this.updatePreview();
        }, { signal });
        this.updatePreview();
      }
      updateVariantPrices(variantId) {
        const prices = JSON.parse(this.querySelector('[data-preview-prices]').textContent);
        const price = prices.find(item => String(item.id) === String(variantId));
        if (!price) return;
        this.querySelector('[data-once-price]').textContent = price.once;
        this.querySelector('[data-subscription-price]').textContent = price.subscription;
        this.querySelector('[data-summary-price]').textContent = price.subscription;
      }
      updatePreview() {
        const active = this.querySelector('input[value="subscribe"]').checked;
        const select = this.querySelector('[data-preview-frequency]');
        this.querySelector('[data-preview-details]').hidden = !active;
        this.querySelector('[data-summary-frequency]').textContent = select.selectedOptions[0].textContent;
        this.restorePurchaseControls();
        this.previewActive = active;
        if (!active || !this.previewSection) return;
        const id = this.dataset.productId;
        const components = this.previewSection.querySelectorAll('product-form-component[data-product-id="' + id + '"]');
        components.forEach(component => {
          component.setAttribute('data-conlemany-preview-paused', '');
          this.previewTargets.push(component);
          const note = document.createElement('div');
          note.className = 'conlemany-subscription-preview__checkout-note';
          note.setAttribute('role', 'status');
          const title = document.createElement('strong');
          title.textContent = this.dataset.blockedLabel;
          const explanation = document.createElement('span');
          explanation.textContent = this.dataset.previewNote;
          note.append(title, explanation);
          component.append(note);
          this.previewNotices.push(note);
        });
        this.previewSection.querySelectorAll('sticky-add-to-cart[data-product-id="' + id + '"]').forEach(sticky => {
          sticky.setAttribute('data-conlemany-preview-paused', '');
          this.previewTargets.push(sticky);
        });
      }
      restorePurchaseControls() {
        (this.previewTargets || []).forEach(target => target.removeAttribute('data-conlemany-preview-paused'));
        (this.previewNotices || []).forEach(note => note.remove());
        this.previewTargets = [];
        this.previewNotices = [];
      }
      disconnectedCallback() {
        this.previewController?.abort();
        this.restorePurchaseControls();
        this.previewController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["conlemany-subscriptions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('conlemany-subscriptions')) {
    customElements.define('conlemany-subscriptions', class extends HTMLElement {
      connectedCallback() {
        if (this.subscriptionController) return;
        this.subscriptionController = new AbortController();
        this.subscriptionSection = this.closest('.shopify-section');
        this.variants = JSON.parse(this.querySelector('[data-subscription-variants]').textContent);
        this.once = this.querySelector('input[value="once"]');
        this.subscribe = this.querySelector('input[value="subscribe"]');
        this.frequency = this.querySelector('[data-subscription-frequency]');
        const { signal } = this.subscriptionController;
        this.addEventListener('change', () => this.updateSelection(), { signal });
        this.subscriptionSection?.addEventListener('variant:update', event => {
          if (event.detail?.data?.productId && String(event.detail.data.productId) !== this.dataset.productId) return;
          const variantId = event.detail?.resource?.id;
          if (variantId && String(variantId) !== this.dataset.variantId) this.setVariant(String(variantId));
        }, { signal });
        this.subscriptionSection?.addEventListener('submit', event => {
          const component = event.target.closest('product-form-component');
          if (component?.dataset.productId !== this.dataset.productId) return;
          this.updateSelection();
          const input = event.target.querySelector('[data-conlemany-selling-plan]');
          if (this.subscribe.checked && (!input || input.disabled || input.value !== this.frequency.value)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.querySelector('[data-subscription-error]').hidden = false;
          }
        }, { signal, capture: true });
        this.setVariant(this.dataset.variantId);
      }
      setVariant(id) {
        this.dataset.variantId = id;
        this.currentVariant = this.variants.find(variant => variant.id === id);
        const plans = this.currentVariant?.plans || [];
        this.frequency.replaceChildren(...plans.map(plan => {
          const option = document.createElement('option');
          option.value = plan.id;
          option.textContent = plan.label;
          return option;
        }));
        if (plans.length) this.frequency.value = (plans[1] || plans[0]).id;
        this.subscribe.disabled = plans.length === 0;
        this.querySelector('[data-subscribe-option]').hidden = plans.length === 0;
        this.hidden = plans.length === 0;
        this.once.checked = this.dataset.required !== 'true';
        this.subscribe.checked = this.dataset.required === 'true' && plans.length > 0;
        if (this.currentVariant) this.querySelector('[data-once-price]').textContent = this.currentVariant.once;
        this.updateSelection();
      }
      updateSelection() {
        const plan = this.currentVariant?.plans.find(item => item.id === this.frequency.value);
        const active = this.subscribe.checked && !!plan;
        this.querySelector('[data-subscription-details]').hidden = !active;
        this.querySelector('[data-subscription-error]').hidden = true;
        if (plan) {
          this.querySelector('[data-subscription-price]').textContent = plan.price;
          this.querySelector('[data-summary-price]').textContent = plan.price;
          this.querySelector('[data-summary-frequency]').textContent = plan.label;
          this.querySelector('[data-savings]').textContent = plan.discount > 0
            ? this.dataset.saveLabel.replace('[percentage]', plan.discount)
            : this.dataset.regularLabel;
        }
        this.subscriptionSection?.querySelectorAll('product-form-component').forEach(component => {
          if (component.dataset.productId !== this.dataset.productId) return;
          const form = component.querySelector('form');
          if (!form) return;
          let input = form.querySelector('[data-conlemany-selling-plan]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.setAttribute('data-conlemany-selling-plan', '');
            form.append(input);
          }
          const nextValue = active ? plan.id : '';
          const changed = input.value !== nextValue || input.disabled === active;
          input.value = nextValue;
          input.disabled = !active;
          if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      disconnectedCallback() {
        this.subscriptionController?.abort();
        this.subscriptionController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
